import configure from 'redux-idle-monitor';
import { IDLE_STATUSES } from '../../constants/idle-monitor-statuses';
import { idleStatusDelay, activeStatusAction, idleStatusAction } from '../../actions/idle-monitor';
 
const activeEvents =  [ 'mousemove', 'keydown', 'wheel', 'DOMMouseScroll', 'mouseWheel', 'mousedown', 'touchstart', 'touchmove', 'MSPointerDown', 'MSPointerMove' ];

const opts = {
    appName: 'apli',
    IDLE_STATUSES, 
    idleStatusDelay, 
    activeStatusAction, 
    idleStatusAction, 
    activeEvents
 };
 
const { middleware, reducer, actions } = configure(opts);
export { middleware, reducer, actions };


// WEBPACK FOOTER //
// ./src/tools/idle-monitor/index.js